<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width:100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
        </a-anchor>
        <a-page-header class="fun-panel" title="业务发展情况" :sub-title="subTitle" @back="onBack">
            <template v-slot:extra>
                <a-button :loading="loading || saving" v-if="editData.djzt === '提交'" type="danger" @click="onCancel">撤销</a-button>
            </template>
            <a-divider></a-divider>
            <a-layout>
                <a-layout-content>
                    <a-spin :spinning="loading">
                        <a-form ref="form" class="fun-edit-form" :label-col="{ span: 12 }" :wrapper-col="{ span: 12 }" style="padding:10px 20px;">
                            <FGCollapsiblePanel title="基本信息">
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="8">
                                        <a-form-item label="统一社会信用代码">
                                            <a-input ref="tyshxydm" v-model="editData.tyshxydm" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="单位名称">
                                            <a-input ref="xdwmc" v-model="editData.xdwmc" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="单位成立时间">
                                            <a-input ref="dwclsj" v-model="editData.dwclsj" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="法定代表人">
                                            <a-input ref="frdb" v-model="editData.frdb" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="注册资本（万元）">
                                            <a-input-number ref="zczj" v-model="editData.zczj" style="width:100%" :min="0" :precision="6" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="币种">
                                            <a-input ref="bzmc" v-model="editData.bzmc" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="联系人姓名">
                                            <a-input ref="lxr" v-model="editData.lxr" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="联系人固定电话">
                                            <a-input ref="gddh" v-model="editData.gddh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="联系人手机号">
                                            <a-input ref="yddh" v-model="editData.yddh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="联系人电子邮箱">
                                            <a-input ref="dzyx" v-model="editData.dzyx" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="备案编号">
                                            <a-input ref="babh" v-model="editData.babh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="单位类型">
                                            <FGDictSelectCN dictNo="DW100103" v-model="editData.dwxz" placeholder="" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="是否上市">
                                            <FGDictSelectCN dictNo="1101" v-model="editData.sfss" placeholder="" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="营收规模">
                                            <FGDictSelectCN dictNo="HY100203" v-model="editData.ysgm" placeholder="" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="其中工程咨询营收规模">
                                            <FGDictSelectCN dictNo="HY100203" v-model="editData.gczxysgm" placeholder="" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="通讯地址">
                                            <a-input ref="txdz" v-model="editData.txdz" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="单位网址">
                                            <a-input ref="dwwz" v-model="editData.dwwz" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="所在城市">
                                            <a-input ref="qymc" v-model="editData.qymc" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="初次开展工程咨询年份">
                                            <a-input ref="cckzzxsj" v-model="editData.cckzzxsj" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <!-- <a-form-item label="工程咨询单位资信等级" required>
                                            <FGDictSelectCN dictNo="1101" v-model="editData.zxdj" placeholder="" />
                                        </a-form-item> -->
                                        <a-form-item label="工程咨询单位资信等级">
                                            <a-input ref="zxdj" v-model="editData.zxdj" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="甲级综合资信情况">
                                            <FGDictSelectCN dictNo="HY100201" v-model="editData.jjzhzxqk" placeholder="" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="甲级专业资信个数">
                                            <a-input-number ref="jjzyzxgs" v-model="editData.jjzyzxgs" :min="0" style="width:100%" :precision="0" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="乙级专业资信个数">
                                            <a-input-number ref="yjzyzxgs" v-model="editData.yjzyzxgs" :min="0" style="width:100%" :precision="0" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="PPP咨询专项资信个数">
                                            <a-input-number ref="yjzyzxgs" v-model="editData.pppzxzxzxqk" :min="0" style="width:100%" :precision="0" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="工程勘察资质">
                                            <FGDictSelectCN dictNo="HY100202" v-model="editData.gckczz" placeholder="" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="工程设计资质">
                                            <FGDictSelectCN dictNo="HY100202" v-model="editData.gcsjzz" placeholder="" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="工程监理资质">
                                            <FGDictSelectCN dictNo="HY100202" v-model="editData.gcjlzz" placeholder="" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="对外承包工程资格">
                                            <FGDictSelectCN dictNo="HY100202" v-model="editData.dwcbgczg" placeholder="" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="保密资质">
                                            <FGDictSelectCN dictNo="HY100202" v-model="editData.bmzz" placeholder="" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="录入部门">
                                            <a-input ref="lrbmmc" v-model="editData.lrbmmc" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="填表人">
                                            <a-input ref="lrr" v-model="editData.lrr" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="填表时间">
                                            <a-date-picker ref="lrrq" v-model="editData.lrrq" valueFormat="YYYY-MM-DD" style="width:100%" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item label="备注" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
                                            <a-textarea v-model="editData.bz" :rows="3" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </FGCollapsiblePanel>
                        </a-form>
                        <!-- 专业类别明细表格 -->
                        <!-- <FGCollapsiblePanel title="专业类别明细">
                            <vxe-table
                                ref="itemTable"
                                size="mini"
                                resizable
                                keep-source
                                auto-resize
                                row-id="id"
                                align="left"
                                header-align="center"
                                highlight-hover-row
                                show-overflow="tooltip"
                                :data="editItemData"
                            >
                                <vxe-table-column type="seq" title="序号" width="100" align="center"></vxe-table-column>
                                <vxe-table-column field="zymc" title="业务领域" min-width="200">
                                    <template v-slot:edit="scope">
                                        <a-input size="small" v-model="scope.row.zymc" />
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="xms" title="项目数(个)" width="250" align="right">
                                    <template v-slot:edit="scope">
                                        <a-input size="small" v-model="scope.row.xms" />
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="xmztze" title="项目总投资额(亿元)" width="200" align="right">
                                    <template v-slot:edit="scope">
                                        <a-input size="small" v-model="scope.row.xmztze" />
                                    </template>
                                </vxe-table-column>
                            </vxe-table>
                        </FGCollapsiblePanel> -->
                        <!-- 人员情况明细表格 -->
                        <FGCollapsiblePanel title="人员情况表">
                            <vxe-table
                                ref="itemTableRYMX"
                                size="mini"
                                resizable
                                keep-source
                                auto-resize
                                row-id="id"
                                align="left"
                                header-align="center"
                                highlight-hover-row
                                show-overflow="tooltip"
                                :data="editItemDataRYMX"
                            >
                                <!-- <vxe-table-column type="seq" title="序号" width="100" align="center"></vxe-table-column> -->
                                <vxe-table-column field="zbmc" title="指标名称" width="400">
                                    <template v-slot="{ row }">
                                        <span style="white-space: pre;">{{ row.zbmc }}</span>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="jldw" title="计量单位" width="120" align="center"></vxe-table-column>
                                <!-- <vxe-table-column field="dm" title="代码" width="150" align="center"></vxe-table-column> -->
                                <vxe-table-column field="sl" title="数量" width="150" align="center"></vxe-table-column>
                                <!-- <vxe-table-column field="djzzysl" title="登记主专业数量" width="200" align="right"></vxe-table-column>
                                <vxe-table-column field="djfzysl" title="登记辅专业数量" width="200" align="right"></vxe-table-column> -->
                                <vxe-table-column field="zbsm" title="指标说明" min-width="300">
                                    <template v-slot="{ row }">
                                        <span style="white-space: pre;">{{ row.zbsm }}</span>
                                    </template>
                                </vxe-table-column>
                            </vxe-table>
                        </FGCollapsiblePanel>
                        <!-- 工程咨询单位业务情况明细表格 -->
                        <FGCollapsiblePanel title="业务状况表">
                            <vxe-table
                                ref="itemTableYWMX"
                                size="mini"
                                resizable
                                keep-source
                                auto-resize
                                row-id="id"
                                align="left"
                                header-align="center"
                                highlight-hover-row
                                show-overflow="tooltip"
                                :data="editItemDataYWMX"
                            >
                                <!-- <vxe-table-column type="seq" title="序号" width="100" align="center"></vxe-table-column> -->
                                <vxe-table-column field="zbmc" title="指标名称" width="400">
                                    <template v-slot="{ row }">
                                        <span style="white-space: pre;">{{ row.zbmc }}</span>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="jldw" title="计量单位" width="120" align="center"></vxe-table-column>
                                <!-- <vxe-table-column field="dm" title="代码" width="150" align="center"></vxe-table-column> -->
                                <vxe-table-column field="sl" title="数量" width="150" align="center"></vxe-table-column>
                                <vxe-table-column field="zbsm" title="指标说明" min-width="300">
                                    <template v-slot="{ row }">
                                        <span style="white-space: pre;">{{ row.zbsm }}</span>
                                    </template>
                                </vxe-table-column>
                            </vxe-table>
                        </FGCollapsiblePanel>
                        <!-- 工程咨询单位财务状况明细表格 -->
                        <FGCollapsiblePanel title="财务状况表">
                            <vxe-table
                                ref="itemTableCWMX"
                                size="mini"
                                resizable
                                keep-source
                                auto-resize
                                row-id="id"
                                align="left"
                                header-align="center"
                                highlight-hover-row
                                show-overflow="tooltip"
                                :data="editItemDataCWMX"
                            >
                                <!-- <vxe-table-column type="seq" title="序号" width="100" align="center"></vxe-table-column> -->
                                <vxe-table-column field="zbmc" title="指标名称" width="400">
                                    <template v-slot="{ row }">
                                        <span style="white-space: pre;">{{ row.zbmc }}</span>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="jldw" title="计量单位" width="120" align="center"></vxe-table-column>
                                <!-- <vxe-table-column field="dm" title="代码" width="150" align="center"></vxe-table-column> -->
                                <vxe-table-column field="zfc" title="增减" width="150" align="center"></vxe-table-column>
                                <vxe-table-column field="zbsm" title="指标说明" min-width="300">
                                    <template v-slot="{ row }">
                                        <span style="white-space: pre;">{{ row.zbsm }}</span>
                                    </template>
                                </vxe-table-column>
                            </vxe-table>
                        </FGCollapsiblePanel>
                        <!-- 工程咨询业务能力及创新状况明细表格 -->
                        <FGCollapsiblePanel title="业务能力及创新状况表">
                            <vxe-table
                                ref="itemTableYWCXMX"
                                size="mini"
                                resizable
                                keep-source
                                auto-resize
                                row-id="id"
                                align="left"
                                header-align="center"
                                highlight-hover-row
                                show-overflow="tooltip"
                                :data="editItemDataYWCXMX"
                            >
                                <!-- <vxe-table-column type="seq" title="序号" width="100" align="center"></vxe-table-column> -->
                                <vxe-table-column field="zbmc" title="指标名称" width="400">
                                    <template v-slot="{ row }">
                                        <span style="white-space: pre;">{{ row.zbmc }}</span>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="jldw" title="计量单位" width="120" align="center"></vxe-table-column>
                                <!-- <vxe-table-column field="dm" title="代码" width="150" align="center"></vxe-table-column> -->
                                <vxe-table-column field="sl" title="数量" width="150" align="center">
                                    <template v-slot="{ row }">
                                        <!-- 如果是字典项，展示 zfc；否则展示 sl -->
                                        <span v-if="row.dm === '250' || row.dm === '251' || row.dm === '252'">
                                            {{ row.zfc }}
                                        </span>
                                        <span v-else>
                                            {{ row.sl }}
                                        </span>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="zbsm" title="指标说明" min-width="300">
                                    <template v-slot="{ row }">
                                        <span style="white-space: pre;">{{ row.zbsm }}</span>
                                    </template>
                                </vxe-table-column>
                            </vxe-table>
                        </FGCollapsiblePanel>
                        <!-- 工程咨询单位社会影响力状况明细表格 -->
                        <FGCollapsiblePanel title="社会影响力状况表">
                            <vxe-table
                                ref="itemTableSHYXLMX"
                                size="mini"
                                resizable
                                keep-source
                                auto-resize
                                row-id="id"
                                align="left"
                                header-align="center"
                                highlight-hover-row
                                show-overflow="tooltip"
                                :data="editItemDataSHYXLMX"
                            >
                                <!-- <vxe-table-column type="seq" title="序号" width="100" align="center"></vxe-table-column> -->
                                <vxe-table-column field="zbmc" title="指标名称" width="400">
                                    <template v-slot="{ row }">
                                        <span style="white-space: pre;">{{ row.zbmc }}</span>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="jldw" title="计量单位" width="120" align="center"></vxe-table-column>
                                <!-- <vxe-table-column field="dm" title="代码" width="150" align="center"></vxe-table-column> -->
                                <vxe-table-column field="sl" title="数量" mini-width="150" align="center">
                                    <template v-slot="{ row }">
                                        <!-- 如果是字典项，展示 zfc；否则展示 sl -->
                                        <a-textarea
                                            v-if="row.dm === '256'"
                                            v-model="row.zfc"
                                            :maxLength="200"
                                            :auto-size="{ minRows: 3, maxRows: 6 }"
                                            style="width: 400px; min-height: 64px; resize: vertical;"
                                            disabled
                                        />
                                        <span v-else>
                                            {{ row.sl }}
                                        </span>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="zbsm" title="指标说明" min-width="300">
                                    <template v-slot="{ row }">
                                        <span style="white-space: pre;">{{ row.zbsm }}</span>
                                    </template>
                                </vxe-table-column>
                            </vxe-table>
                        </FGCollapsiblePanel>
                        <!-- 工程咨询单位排名申报表明细表格 -->
                        <!-- <FGCollapsiblePanel title="排名申报表">
                            <vxe-table
                                ref="itemTablePMMX"
                                size="mini"
                                resizable
                                keep-source
                                auto-resize
                                row-id="id"
                                align="left"
                                header-align="center"
                                highlight-hover-row
                                show-overflow="tooltip"
                                :data="editItemDataPMMX"
                            >
                                <vxe-table-column type="seq" title="序号" width="100" align="center"></vxe-table-column>
                                <vxe-table-column field="dm" title="代码" width="150" align="center"></vxe-table-column>
                                <vxe-table-column field="mc" title="名称" min-width="200"></vxe-table-column>
                                <vxe-table-column field="sfsb" title="是否申报" width="200" align="center"></vxe-table-column>
                            </vxe-table>
                        </FGCollapsiblePanel> -->
                        <!-- 工程咨询单位业务发展判断明细表格 -->
                        <!-- <FGCollapsiblePanel title="业务发展判断表">
                            <vxe-table
                                ref="itemTableYWFZPDMX"
                                size="mini"
                                resizable
                                keep-source
                                auto-resize
                                row-id="id"
                                align="left"
                                header-align="center"
                                highlight-hover-row
                                show-overflow="tooltip"
                                :data="editItemDataYWFZPDMX"
                            >
                                <vxe-table-column type="seq" title="序号" width="100" align="center"></vxe-table-column>
                                <vxe-table-column field="dm" title="代码" width="150" align="center"></vxe-table-column>
                                <vxe-table-column field="mc" title="名称" min-width="200"></vxe-table-column>
                                <vxe-table-colgroup title="状态">
                                    <vxe-table-column field="yjdzt" title="2022年一季度" width="150" align="center"></vxe-table-column>
                                    <vxe-table-column field="ejdzt" title="2022年二季度" width="150" align="center"></vxe-table-column>
                                    <vxe-table-column field="sjdzt" title="2022年三季度" width="150" align="center"></vxe-table-column>
                                    <vxe-table-column field="fjdzt" title="2022年四季度" width="150" align="center"></vxe-table-column>
                                </vxe-table-colgroup>
                            </vxe-table>
                        </FGCollapsiblePanel> -->
                    </a-spin>
                    <!-- 操作日志 -->
                    <OperLog ref="operlog" :operLogProps="operLogProps"></OperLog>
                </a-layout-content>
                <a-layout-sider class="region-attach-uploadpanel">
                    <AttachDownload :attachCfg.sync="attachCfg" />
                </a-layout-sider>
            </a-layout>
        </a-page-header>
    </div>
</template>
<script>
export default {
    name: "YwfzqkdjForm",
    props: ["showEdit", "dataId"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 主表数据
            editData: {},
            editDataLoading: false,
            // 明细数据
            editItemData: [],
            editItemDataLoading: false,
            // 人员明细数据
            editItemDataRYMX: [],
            editItemDataRYMXLoading: false,
            // 业务明细数据
            editItemDataYWMX: [],
            editItemDataYWMXLoading: false,
            // 财务明细数据
            editItemDataCWMX: [],
            editItemDataCWMXLoading: false,
            // 业务能力及创新明细数据
            editItemDataYWCXMX: [],
            editItemDataYWCXMXLoading: false,
            // 社会影响力明细数据
            editItemDataSHYXLMX: [],
            editItemDataSHYXLMXLoading: false,
            // 排名申报明细数据
            editItemDataPMMX: [],
            editItemDataPMMXLoading: false,
            // 业务发展判断明细数据
            editItemDataYWFZPDMX: [],
            editItemDataYWFZPDMXLoading: false,
            isShow_gzxz: false,
            isShow_sfss: false,
            isShow_pppzxyw: false,
            isShow_jyzxyw: false,
            isShow_ydylzxyw: false,
            isShow_gczxxmhj: false,
            isShow_cyzdbzgf: false,
            // 流程跟踪参数
            operLogProps: {
                visible: false,
                billid: null
            }
        };
    },
    computed: {
        subTitle() {
            return "查看";
        }, // 是否显示编辑界面
        formIsVisible: {
            get() {
                return this.showForm;
            },
            set(newVal) {
                this.$emit("update:showForm", newVal);
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        },
        loading() {
            return this.editDataLoading || this.editItemDataLoading;
        },
        //附件参数
        attachCfg() {
            return {
                fktable: "HY_YWFZQK",
                fkfield: "ID",
                attachsource: "HY1002",
                fkvalue: this.editData.id
            };
        }
    },
    watch: {
        "editData.gzxz": function(val, oldval) {
            if (val !== undefined) {
                if (val !== oldval) {
                    if (val === "已改制") {
                        this.isShow_gzxz = true;
                    } else {
                        this.isShow_gzxz = false;
                    }
                }
            }
        },
        "editData.sfss": function(val, oldval) {
            if (val !== undefined) {
                if (val !== oldval) {
                    if (val === "是") {
                        this.isShow_sfss = true;
                    } else {
                        this.isShow_sfss = false;
                    }
                }
            }
        },
        "editData.pppzxyw": function(val, oldval) {
            if (val !== undefined) {
                if (val !== oldval) {
                    if (val === "是") {
                        this.isShow_pppzxyw = true;
                    } else {
                        this.isShow_pppzxyw = false;
                    }
                }
            }
        },
        "editData.jyzxyw": function(val, oldval) {
            if (val !== undefined) {
                if (val !== oldval) {
                    if (val === "是") {
                        this.isShow_jyzxyw = true;
                    } else {
                        this.isShow_jyzxyw = false;
                    }
                }
            }
        },
        "editData.ydylzxyw": function(val, oldval) {
            if (val !== undefined) {
                if (val !== oldval) {
                    if (val === "是") {
                        this.isShow_ydylzxyw = true;
                    } else {
                        this.isShow_ydylzxyw = false;
                    }
                }
            }
        },
        "editData.gczxxmhj": function(val, oldval) {
            if (val !== undefined) {
                if (val !== oldval) {
                    if (val === "是") {
                        this.isShow_gczxxmhj = true;
                    } else {
                        this.isShow_gczxxmhj = false;
                    }
                }
            }
        },
        "editData.cyzdbzgf": function(val, oldval) {
            if (val !== undefined) {
                if (val !== oldval) {
                    if (val === "是") {
                        this.isShow_cyzdbzgf = true;
                    } else {
                        this.isShow_cyzdbzgf = false;
                    }
                }
            }
        }
    },
    activated() {
        this.loadData();
    },
    methods: {
        // 根据id查询需要编辑的数据
        loadData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/hydcgl/hydc/selectById",
                    {
                        id: this.dataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                            this.loadItemData();
                            this.loadItemDataRYMX();
                            this.loadItemDataYWMX();
                            this.loadItemDataCWMX();
                            this.loadItemDataYWCXMX();
                            this.loadItemDataSHYXLMX();
                            this.loadItemDataPMMX();
                            this.loadItemDataYWFZPDMX();
                            this.initOperLog();
                        } else {
                            // 加载的数据不存在则提示错误并关闭编辑窗口
                            this.$FG_message.error("P0002").then(() => (this.formIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则关闭弹窗
                        this.formIsVisible = false;
                    }
                });
        },
        // 加载明细表数据
        loadItemData() {
            this.editItemData = [];
            this.editItemDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/hydcgl/hydc/listMX",
                    {
                        djid: this.editDataId,
                        sort: {
                            field: "XH ",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataLoading = false;
                    if (success) {
                        this.editItemData = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 加载人员情况明细表数据
        loadItemDataRYMX() {
            this.editItemDataRYMX = [];
            this.editItemDataRYMXLoading = true;
            this.$FG_http
                .post(
                    "./api/main/hydcgl/hydc/listRYMX",
                    {
                        djid: this.dataId,
                        sort: {
                            field: "XH ",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataRYMXLoading = false;
                    if (success) {
                        this.editItemDataRYMX = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 加载业务情况表明细表数据
        loadItemDataYWMX() {
            this.editItemDataYWMX = [];
            this.editItemDataYWMXLoading = true;
            this.$FG_http
                .post(
                    "./api/main/hydcgl/hydc/listYWMX",
                    {
                        djid: this.dataId,
                        sort: {
                            field: "XH ",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataYWMXLoading = false;
                    if (success) {
                        this.editItemDataYWMX = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 加载财务明细表数据
        loadItemDataCWMX() {
            this.editItemDataCWMX = [];
            this.editItemDataCWMXLoading = true;
            this.$FG_http
                .post(
                    "./api/main/hydcgl/hydc/listCWMX",
                    {
                        djid: this.dataId,
                        sort: {
                            field: "XH ",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataCWMXLoading = false;
                    if (success) {
                        this.editItemDataCWMX = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 加载业务能力及创新状况明细表数据
        loadItemDataYWCXMX() {
            this.editItemDataYWCXMX = [];
            this.editItemDataYWCXMXLoading = true;
            this.$FG_http
                .post(
                    "./api/main/hydcgl/hydc/listYWCXMX",
                    {
                        djid: this.dataId,
                        sort: {
                            field: "XH ",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataYWCXMXLoading = false;
                    if (success) {
                        this.editItemDataYWCXMX = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 加载社会影响力明细表数据
        loadItemDataSHYXLMX() {
            this.editItemDataSHYXLMX = [];
            this.editItemDataSHYXLMXLoading = true;
            this.$FG_http
                .post(
                    "./api/main/hydcgl/hydc/listSHYXLMX",
                    {
                        djid: this.dataId,
                        sort: {
                            field: "XH ",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataSHYXLMXLoading = false;
                    if (success) {
                        this.editItemDataSHYXLMX = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 加载排名申报明细表数据
        loadItemDataPMMX() {
            this.editItemDataPMMX = [];
            this.editItemDataPMMXLoading = true;
            this.$FG_http
                .post(
                    "./api/main/hydcgl/hydc/listPMMX",
                    {
                        djid: this.dataId,
                        sort: {
                            field: "XH ",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataPMMXLoading = false;
                    if (success) {
                        this.editItemDataPMMX = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 加载业务发展判断明细表数据
        loadItemDataYWFZPDMX() {
            this.editItemDataYWFZPDMX = [];
            this.editItemDataYWFZPDMXLoading = true;
            this.$FG_http
                .post(
                    "./api/main/hydcgl/hydc/listYWFZPDMX",
                    {
                        djid: this.dataId,
                        sort: {
                            field: "XH ",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataYWFZPDMXLoading = false;
                    if (success) {
                        this.editItemDataYWFZPDMX = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 返回列表
        onBack() {
            this.formIsVisible = false;
            // 重置编辑数据ID，避免影响下次操作
            this.editDataId = null;
        },
        //撤销操作
        onCancel(type) {
            this.$FG_message.confirm("P0000", "撤销").then((type) => {
                if (type === "ok") {
                    this.loading = true;
                    this.$FG_http
                        .post("./api/main/hydcgl/hydc/unSubmit", {
                            id: this.editData.id
                        })
                        .then(({ success, data, errMsg }) => {
                            this.saving = false;
                            if (success) {
                                // 设置当前行
                                this.lookDataId = this.editData.id;
                                // 返回列表
                                this.formIsVisible = false;
                            }
                        });
                }
            });
        },
        initOperLog() {
            this.operLogProps.visible = true;
            this.operLogProps.billid = this.editData.id;
        }
    }
};
</script>
<style scoped>
:deep(.vxe-table--render-default.size--mini .vxe-body--column.col--ellipsis > .vxe-cell) {
    max-height: none !important;
    white-space: pre-wrap;
    word-break: break-all;
}

:deep(.vxe-table--render-default.size--mini .vxe-body--column > .vxe-cell) {
    white-space: pre-wrap;
    word-break: break-all;
}
/* 完全隐藏数字输入框的上下箭头 */
:deep(.ant-input-number-handler-wrap) {
    display: none !important;
}
</style>
